import { render, staticRenderFns } from "./BasicInfoModelo.vue?vue&type=template&id=35edae0a&"
import script from "./BasicInfoModelo.vue?vue&type=script&lang=js&"
export * from "./BasicInfoModelo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoModelo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VForm,VRow,VTextField})
